// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1CoxR","inputWrap":"styles_inputWrap__cbkVy","input":"styles_input__aGljR"};